import React from 'react';
import { Clickable, Constrain, LoadingBalls, Stack, Text } from '@moda/om';
import { colors } from '@moda/tokens';
import ExitIcon from '@moda/icons/exit-16';
import WarningIcon from '@moda/icons/warning-16';
import { useCheckoutGiftSectionConfigurator } from '../../CheckoutGiftSection/CheckoutGiftSectionConfigurator/useCheckoutGiftSectionConfigurator';
import { useCheckoutGiftSectionError } from './useCheckoutGiftSectionError';

import './CheckoutGiftSectionError.scss';

export const CheckoutGiftSectionError: React.FC = () => {
  const { handleDisable, loading } = useCheckoutGiftSectionConfigurator();

  const error = useCheckoutGiftSectionError();

  if (!error) return null;

  return (
    <Constrain>
      <Stack className="CheckoutGiftSectionError" direction="horizontal" space={4}>
        <WarningIcon color={colors.all['code-red']} />

        <Stack
          className="CheckoutGiftSectionError__content"
          direction="horizontal"
          justifyContent="space-between"
          space={1}
        >
          <Stack space={2}>
            <Stack space={2} direction="horizontal" justifyContent="space-between">
              <Text color="code-red">Gifting Update</Text>

              {loading && <LoadingBalls />}
            </Stack>

            <Text>{error}</Text>
          </Stack>

          <Clickable className="CheckoutGiftSectionError__closer" onClick={handleDisable}>
            <ExitIcon />
          </Clickable>
        </Stack>
      </Stack>
    </Constrain>
  );
};
